(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slider"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper('.swiper', {

  loop: true,
  speed: 1000,
   autoplay: {
     delay: 5000,
   },
  spaceBetween: 10,


  pagination: {
    el: '.swiper-pagination',
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});  

  } catch(e) { console.error(e); }
})();
})();
